import { Zap } from "lucide-react";
import { MARQUEE_ITEMS } from "../mock";

const Row = () => (
  <div className="flex items-center shrink-0">
    {MARQUEE_ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-condensed font-bold uppercase tracking-[0.2em] text-white/95 text-lg sm:text-xl px-8 py-4 whitespace-nowrap">
          {item}
        </span>
        <Zap className="w-4 h-4 text-[#4caf7d] shrink-0" fill="currentColor" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="bg-[#c8102e] overflow-hidden border-y-4 border-[#191512]">
    <div className="marquee-track">
      <Row />
      <Row />
    </div>
  </div>
);
